import { Avatar, Card, CardContent, Stack, Typography } from '@mui/material'
import { FC } from 'react'
import { EmphasizedNumber, Icons, ItemImageArea } from 'utoniq-ui'

import { OrderedItemBoxFragment } from '@/clients/utoniq-core/schema'
import { styleSets } from '@/components/styles'
import { useTranslation } from '@/core'

type OrderedItemBox = {
  orderItem: OrderedItemBoxFragment
}

export const OrderedItemBox: FC<OrderedItemBox> = ({ orderItem }) => {
  const { t } = useTranslation('consoleItemOrders')
  return (
    <Card sx={{ borderRadius: 2 }} elevation={0}>
      <CardContent sx={{ p: 5 }}>
        <Stack spacing={4}>
          <Stack direction="row" spacing={4}>
            <ItemImageArea
              src={orderItem.item?.thumbnail.front?.smallUri ?? ''}
              size="small"
            />
            <Stack flex={1} spacing={2}>
              <Stack sx={{ minWidth: 0 }}>
                <Typography
                  variant="subtitle1"
                  sx={{ ...styleSets.lineCamp(1) }}
                >
                  {orderItem.item?.title}
                </Typography>
                {!!orderItem.serials?.[0]?.sku?.unitName && (
                  <Typography variant="body2">
                    {orderItem.serials?.[0]?.sku?.unitName}
                  </Typography>
                )}
              </Stack>

              <Stack spacing={1}>
                <Stack spacing={1} direction="row" alignItems="center">
                  {!isNaN(orderItem.prepaidPoint ?? NaN) ? (
                    <>
                      <Icons.Point />
                      <EmphasizedNumber variant="h2">
                        {orderItem.prepaidPoint}
                      </EmphasizedNumber>
                    </>
                  ) : (
                    <EmphasizedNumber variant="h2">
                      ¥ {orderItem.price}
                    </EmphasizedNumber>
                  )}
                </Stack>
                {!!orderItem.purchaseNumber && (
                  <Stack direction="row" spacing={1}>
                    <Typography variant="body2" color="text.hint">
                      {t('quantity', {
                        number: orderItem.purchaseNumber ?? 0,
                      })}
                    </Typography>
                  </Stack>
                )}
              </Stack>
            </Stack>
          </Stack>
          <Stack direction="row" spacing={4} alignItems="center">
            <Avatar
              src={orderItem.user?.avatar?.smallUri ?? ''}
              sx={{ width: 28, height: 28 }}
            />
            <Typography variant="body2">
              {orderItem.formattedCreatedAt}
            </Typography>
          </Stack>
        </Stack>
      </CardContent>
    </Card>
  )
}
